<template>
    <!-- 新增网点 -->
    <div class="page-container">
        <div class="form-layout">
            <el-form :model="form" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="用户ID：" prop="user_no">
                    <div>
                        <el-button type="primary" @click="createCode">获取二维码</el-button>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" size="small" @click="submitForm('ruleForm')">提 交</el-button>
                    <el-button size="small" @click="resetForm('ruleForm')">重 置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddStorePage',
    data() {
        return {
            form: {
                name: '', // 姓名

            },

        };
    },

    mounted() {
        
    },

    methods: {
        createCode() {
            this.$http({
                method: 'post',
                url: '/cards/cardcode/xhs',
                params: {
                    user_no: '123456'
                }
            })
                .then(res => {
                    console.log('结果：', res)
                })
                .catch(err => {
                    console.error('操作异常：', err.message);
                })
        },



        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.form.is_multiple_phone == '1') {
                        this.form.telephone = JSON.stringify(this.phoneList)
                    }
                    if (this.form.is_multiple_address == '1') {
                        this.form.other_address = JSON.stringify(this.addressList)
                    }
                    if (this.form.card_version == '1') {
                        this.form.personal_version_opentime = this.getCurrentTime()
                    }
                    // 提交表单
                    this.$http({
                        method: 'post',
                        url: '/personal/add',
                        params: {
                            ...this.form,
                            create_time: this.getCurrentTime()
                        }
                    })
                        .then(res => {
                            if (res.errno == 0) {
                                this.$message.success('新增成功')
                                this.resetForm('ruleForm')
                                this.$router.back()
                            } else {
                                this.$message.error('新增失败')
                            }
                        })
                        .catch(err => {
                            this.$message.error('新增失败，服务端异常')
                            console.error('操作异常：', err.message);
                        })
                } else {
                    return false;
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.page-container {
    background: #fff;
    height: 100%;
    width: 100%;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 20px 25px;
    overflow-y: scroll;

    .page-top-tool {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
    }

    .form-layout {
        margin: 30px 0px;
        padding: 10px 30px;
    }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
    width: 4px;
}

.page-container::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
}

.avatar-uploader {
    cursor: pointer;
    position: relative;
    width: 120px;
    height: 120px;
    margin-bottom: 20px;
}

.avatar-uploader-icon:hover {
    border-color: #409EFF;
    color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}

.prview-pic {
    width: 120px;
    display: block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}

.cardpic {
    height: 100px;
    display: block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}

.desc_images {
    height: 100px;
    border: 1px solid red;
    display: block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    overflow: hidden;
}

.copy-link {
    margin-left: 10px;
    color: #409EFF;
}

.copy-link:hover {
    cursor: pointer;
}
</style>